var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['action-menu-button', ("action-menu-button--" + _vm.type)]},[_c('i',{staticClass:"action-menu-button__icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }